/**
 * Created by quikr on 8/1/16.
 */


import * as types from "../../actions/actionTypes";

const Auth = new Object();
Auth.loggedIn = false;
Auth.EmpId = null;
Auth.roles = {recruitment: {rec: false, ops: false, emp: false, admin: false, it: false}};

export default function authReducers(state = [{Auth}], action) {
  switch (action.type) {
    case types.STORE_LOGIN_SUCCESS: {

      return [Object.assign({}, action.Auth)];
    }
    case 'LOGGED_IN': {
      return [Object.assign({}, action.Auth)];
    }
    case 'LOG_OUT_SUCCESS':
      //session.setId(null);
      return [Object.assign({}, action.Auth)];
    case  'STORE_ROLES_SUCCESS':
      return [Object.assign({}, action.Auth)];

    default:
      return [...state];

  }
}




/** WEBPACK FOOTER **
 ** ./src/redux/reducers/Authentication/authReducers.js
 **/